<template>
    <q-header unelevated class="bg-white pd_left_40 pd_right_40" style="border-bottom:1px solid #E0E0E0">
        <q-toolbar class="color_gray_900" style="display: flex;height: 7.17vmin;">
            <p class="home__img">
                <q-icon name="img:/assets/images/icon/ico_home.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
            </p>
            <p class="mg_left_24 mg_right_16 b1 medium line_height_45 header_lesson">{{ studyStore.process.exam?.lesson
            }}레슨</p>
            <q-chip>{{ label }}</q-chip>
            <q-chip>{{ subLabel }}</q-chip>
            <div style="margin-left: 0.67vmin;">
                <CusButton :type="isMenuOpen ? 330: 340"  :class="isMenuOpen ? 'menu__open' : ''" @onReturn="onBtnClick"/>   
            </div>
            <div v-if="isMenuOpen" style="margin-top: 44px;">
                <q-menu v-model="isMenuOpen" transition-show="jump-down" transition-hide="jump-up"
                    anchor="bottom middle" self="top middle" @before-show="() => { isMenuOpen = true }"
                    @before-hide="() => { isMenuOpen = false }"
                    style="border: 2px solid #222222; box-shadow: 0.5vmin 0.5vmin 1.25vmin rgba(0, 0, 0, 0.25); border-radius: 1.33vmin; z-index: 9999;">
                    <div class="pd_all_32 color_gray_900 header__nav">
                        <p class="pd_bottom_16 caption2 bold line_height_26">
                            <!-- {{ studyStore?.level }}레벨 {{ studyStore?.lesson }}레슨 -->
                            {{ studyStore.process.exam?.level }}레벨 {{ studyStore.process.exam?.lesson }}레슨
                        </p>
                        <q-separator />
                        <div v-for="(item, index) in studyStore.mapTree.exams" class="header__content">
                            <div v-if="(studyStore.process.examIdx > 1 ? index > 1 : index < 2)">
                                <div class="title">
                                    <p class="b3 medium line_height_32">[지문{{ ((index === 1 || index === 3 ? 2 : 1))
                                    }}-{{ item?.passageClass }}]
                                    </p>
                                    <p class="mg_top_8 b3 line_height_32">{{ item?.title }}</p>
                                </div>
                                <p class="nav__btn">
                                    <q-btn unelevated :disable="disableCheck(index, 5082)"
                                        :onclick="() => { onClickNav(index, 5082); }">
                                        코어독해
                                        <q-badge
                                            v-if="(((index) === studyStore.process.examIdx) && studyStore.process.studyTree === 5082)"
                                            floating color="red" rounded />
                                    </q-btn>
                                    <q-btn unelevated :disable="disableCheck(index, 5083)"
                                        :onclick="() => { onClickNav(index, 5083); }">
                                        본격독해
                                        <q-badge
                                            v-if="(((index) === studyStore.process.examIdx) && studyStore.process.studyTree === 5083)"
                                            floating color="red" rounded />
                                    </q-btn>
                                    <q-btn unelevated :disable="disableCheck(index, 5084)"
                                        :onclick="() => { onClickNav(index, 5084); }">
                                        어휘학습
                                        <q-badge
                                            v-if="(((index) === studyStore.process.examIdx) && studyStore.process.studyTree === 5084)"
                                            floating color="red" rounded />
                                    </q-btn>
                                </p>
                            </div>
                        </div>
                    </div>
                </q-menu>
            </div>

            <!-- <q-btn flat padding="none" color="black" rounded :class="isMenuOpen ? 'menu__open' : ''"
                :icon="`${isMenuOpen === true ? 'expand_less' : 'expand_more'}`" :onclick="() => { !isMenuOpen }">
                <q-menu v-model="isMenuOpen" transition-show="jump-down" transition-hide="jump-up"
                    anchor="bottom middle" self="top middle" @before-show="() => { isMenuOpen = true }"
                    @before-hide="() => { isMenuOpen = false }"
                    style="border: 2px solid #222222; box-shadow: 0.5vmin 0.5vmin 1.25vmin rgba(0, 0, 0, 0.25); border-radius: 1.33vmin; z-index: 9999;">
                    <div class="pd_all_32 color_gray_900 header__nav">
                        <p class="pd_bottom_16 caption2 bold line_height_26"> -->
                            <!-- {{ studyStore?.level }}레벨 {{ studyStore?.lesson }}레슨 -->
                            <!-- {{ studyStore.process.exam?.level }}레벨 {{ studyStore.process.exam?.lesson }}레슨
                        </p>
                        <q-separator />
                        <div v-for="(item, index) in studyStore.mapTree.exams" class="header__content">
                            <div v-if="(studyStore.process.examIdx > 1 ? index > 1 : index < 2)">
                                <div class="title">
                                    <p class="b3 medium line_height_32">[지문{{ ((index === 1 || index === 3 ? 2 : 1))
                                    }}-{{ item?.passageClass }}]
                                    </p>
                                    <p class="mg_top_8 b3 line_height_32">{{ item?.title }}</p>
                                </div>
                                <p class="nav__btn">
                                    <q-btn unelevated :disable="disableCheck(index, 5082)"
                                        :onclick="() => { onClickNav(index, 5082); }">
                                        코어독해
                                        <q-badge
                                            v-if="(((index) === studyStore.process.examIdx) && studyStore.process.studyTree === 5082)"
                                            floating color="red" rounded />
                                    </q-btn>
                                    <q-btn unelevated :disable="disableCheck(index, 5083)"
                                        :onclick="() => { onClickNav(index, 5083); }">
                                        본격독해
                                        <q-badge
                                            v-if="(((index) === studyStore.process.examIdx) && studyStore.process.studyTree === 5083)"
                                            floating color="red" rounded />
                                    </q-btn>
                                    <q-btn unelevated :disable="disableCheck(index, 5084)"
                                        :onclick="() => { onClickNav(index, 5084); }">
                                        어휘학습
                                        <q-badge
                                            v-if="(((index) === studyStore.process.examIdx) && studyStore.process.studyTree === 5084)"
                                            floating color="red" rounded />
                                    </q-btn>
                                </p>
                            </div>
                        </div>
                    </div>
                </q-menu>
            </q-btn> -->
        </q-toolbar>
    </q-header>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useRouter } from "vue-router";
import { DialogStore } from "@/store/modules/dialog";
import { StudyStore } from "@/store/modules/study";
import { headerEtcCd02, headerEtcCd01, headerEtcCd05, studyTree } from "@/helpers/qbankParser/qbankMeta";
import { useQuasar } from 'quasar';
import CusButton from '@/components/widget/CusButton.vue';

const isMenuOpen = ref(false);
const router = useRouter();
const store = DialogStore();
const studyStore = StudyStore();
const $q = useQuasar();
const label = ref('');
const subLabel = ref('');

const onBtnClick = () => {
    isMenuOpen.value = !isMenuOpen.value;
}

const checkConfirm = (val) => {
    val && router.push('/learninghome');
}

const disableCheck = (passage, sTree) => {
    if (passage < studyStore.process.examIdx) {
        return false;
    } else if (passage > studyStore.process.examIdx) {
        return true;
    } else {
        if (sTree <= studyStore.process.studyTree) {
            return false;
        } else {
            return true;
        }
    }
}
const onClickHome = () => {
    // store.openConfirmDialog({
    //     message: '학습을 중단하고 홈으로 이동하시겠습니까?',
    //     cancel: '닫기',
    //     ok: '확인',
    //     callback: checkConfirm,
    // });
    // $q.dialog({
    //     title: '확인',
    //     message: '학습을 중단하고 홈으로 이동하시겠습니까?',
    //     // ok: {
    //     //     push: true,
    //     //     style: 'width:40%;'
    //     // },
    //     // cancel: {
    //     //     push: true,
    //     //     color: 'red',
    //     //     outline,
    //     //     style: 'width:40%;'
    //     // },
    //     cancel: true,
    //     persistent: true
    // }).onOk(() => {
    //     checkConfirm(true);
    // }).onCancel(() => {
    //     // console.log('>>>> Cancel')
    // })
    // console.log('--onClickHome-onClickHome-')
    store.openConfirmDialog({
        message: '홈으로 이동하시겠습니까?',
        cancel: '닫기',
        ok: '확인',
        callback: checkConfirm,
    });
}

const onClickNav = (idx, treeIdx) => {
    isMenuOpen.value = false;
    if (studyStore.process.examIdx === idx && studyStore.process.studyTree === treeIdx) {
        studyStore.currentInfo = null;
    } else {
        studyStore.setMoveNav(idx, treeIdx);
    }
    setTimeout(() => {
        router.push(treeIdx === 5083 ? "/authenticreading" : treeIdx === 5084 ? "/vocabularylearning" : "/corereading");
    }, 200)
}

onMounted(() => {
    // label.value = headerEtcCd02[studyStore.currentInfo !== null ? studyStore.currentInfo.exam?.headerEtcCd02 : studyStore.process.exam?.headerEtcCd02];
    label.value = studyStore.currentInfo !== null ? studyStore.currentInfo.exam?.area : studyStore.process.exam?.area
    if (studyStore.currentInfo !== null) {
        // label.value += ('-' + (studyStore.currentInfo.exam?.areaCode ===
        //     '02' ? headerEtcCd05[studyStore.currentInfo.exam?.headerEtcCd01] :
        //     headerEtcCd01[studyStore.currentInfo.exam?.headerEtcCd01]))
        label.value += ('-' + (studyStore.currentInfo.exam?.passageClass));
    } else {
        // label.value += ('-' + (studyStore.process.exam?.areaCode ===
        //     '02' ? headerEtcCd05[studyStore.process.exam?.headerEtcCd01] :
        //     headerEtcCd01[studyStore.process.exam?.headerEtcCd01]))
        label.value += ('-' + (studyStore.process.exam?.passageClass));
    }
    subLabel.value = studyStore.currentInfo !== null ? studyTree[studyStore.currentInfo.studyTree] : studyTree[studyStore.process?.studyTree];
});

watch(() => studyStore.currentInfo, (newValue) => {
    // label.value = headerEtcCd02[newValue !== null ? newValue.exam?.headerEtcCd02 : studyStore.process.exam?.headerEtcCd02];
    // if (newValue !== null) {
    //     label.value += ('-' + (newValue.exam?.areaCode ===
    //         '02' ? headerEtcCd05[newValue.exam?.headerEtcCd01] :
    //         headerEtcCd01[newValue.exam?.headerEtcCd01]))
    // } else {
    //     label.value += ('-' + (studyStore.process.exam?.areaCode ===
    //         '02' ? headerEtcCd05[studyStore.process.exam?.headerEtcCd01] :
    //         headerEtcCd01[studyStore.process.exam?.headerEtcCd01]))
    // }
    // label.value = headerEtcCd02[studyStore.currentInfo !== null ? studyStore.currentInfo.exam?.headerEtcCd02 : studyStore.process.exam?.headerEtcCd02];
    label.value = newValue !== null ? newValue.exam?.area : studyStore.process.exam?.area
    if (newValue !== null) {
        label.value += ('-' + (newValue.exam?.passageClass));
    } else {
        label.value += ('-' + (studyStore.process.exam?.passageClass));
    }
    subLabel.value = newValue !== null ? studyTree[newValue.studyTree] : studyTree[studyStore.process?.studyTree];
});
</script>

<style scoped lang="scss">
p {
    margin-bottom: 0;
}

.header {
    &__nav {
        min-width: 300px;
        max-width: 23vw;
    }

    &__content {
        .title {
            margin-top: 2.5vmin;

            p {
                word-break: keep-all;
            }
        }

        &:nth-of-type(n + 2) {
            .title {
                margin-top: 3.33vmin;
            }
        }
    }
}

::v-deep {
    .q-toolbar {
        min-height: inherit;
        // margin: 1.58vmin 0;
        padding: 0;

        .home__img {
            .q-icon {
                display: inline-block;
                width: 2.4vw;
                height: 2.4vw;
                padding: 0.33vmin 0.42vmin;
                box-sizing: border-box;
            }
        }

        .q-chip {
            &:nth-of-type(n + 2) {
                margin-left: 0.67vmin;
            }
        }

        .q-btn {
            width: 2.2vw;
            height: 2.2vw;
            margin-left: 0.8vmin;

            /* &.q-focusable {
                background: $color_primary;
                color: $color_white;
            } */
            &.q-focusable:focus > .q-focus-helper,
            &.q-manual-focusable--focused > .q-focus-helper,
            &.q-hoverable:hover > .q-focus-helper {
                background: inherit;
                opacity: 0;
            }

            .q-icon {
                font-size: 2vw;
            }
        }
    }

    .q-chip {
        margin: 0;
        padding: 0.83vmin 1.33vmin;
        @include border-radius(1.83vmin);
        background: $color_gray_300;
        font-size: 1vw;
        font-weight: 500;
        color: $color_gray_800;
        line-height: 1.3vw;
    }

    .nav__btn {
        margin-top: 1.5vmin;

        button {
            padding: 0.83vmin 1.33vmin;
            background: $color_gray_300;
            font-size: 1vw;
            font-weight: 500;
            color: $color_gray_800;
            line-height: 1.3vw;

            &:nth-of-type(n + 2) {
                margin-left: 0.67vmin;
            }

            &.disabled {
                background: $color_gray_200;
                color: $color_gray_500;
                opacity: 1 !important;
            }
        }
    }

    .menu__open {
        background-color: $primary;
        color: white !important;
    }
}
</style>
